import leftArrow from '@/assets/icons/left-arrow.svg'
import { useNavigate } from "react-router-dom";

export const BackButton = ({
  buttonText,
  buttonLink,
  additionalClassName
}: {
  buttonText: string,
  buttonLink: string,
  additionalClassName?: string
}) => {
  const navigate = useNavigate()
  return (
    <div
      className={`flex flex-row items-center cursor-pointer mb-3 ${additionalClassName ?? ''}`}
      onClick={() => { navigate(buttonLink) }}
    >
      <img src={leftArrow} className='mr-3' alt="" />
      <p className='text-secondary font-semibold text-xs'>
        {buttonText.toUpperCase()}
      </p>
    </div>
  );
};
